import { Injectable } from '@angular/core';
import { ENVIRONMENTS, APP_CONFIG } from '../../../../app.config';

@Injectable({
    providedIn: 'root'
})
export class TermsAndConditionsServiceConfig {

    private configMock: any = { // MOCK - local json settings
        environment: ENVIRONMENTS.mock,
        baseUrl: '',
        apiUrl: {
            termsAndConditionsByService: 'api/v1/TermsAndConditions/TermsAndConditionsByService/{0}',
            consentTermsAndConditions: 'ConsentTermsAndConditions/{0}'
        }
    };

    private configProd: any = { // PRODUCTION - PRODUCTION ENVIRONMENT SETTINGS
        environment: ENVIRONMENTS.prod,
        baseUrl: '',
        apiUrl: {
            termsAndConditionsByService: 'api/v1/TermsAndConditions/TermsAndConditionsByService/{0}',
            consentTermsAndConditions: 'ConsentTermsAndConditions/{0}'
        }
    };

    private _environment: string = APP_CONFIG.ENVIRONMENT;

    constructor() {
        // void
    }

    public getEnvironment(): any {
        switch (this._environment) {
            case ENVIRONMENTS.mock:
                return this.configMock;
            case ENVIRONMENTS.dev:
                return this.configProd;
            case ENVIRONMENTS.test:
                return this.configProd;
            case ENVIRONMENTS.stg:
                return this.configProd;
            case ENVIRONMENTS.prod:
                return this.configProd;
            default:
                return null;
        }
    }

    public setEnvironment(environment: string): any {
        this._environment = environment;
    }
}